export const langStatList = {
  fr: {
    stat_year_head: 'Année',
    stat_nb_head: 'Nb sessions',
    stat_duration_head: 'Durée totale',
  },
  eng: {
    stat_year_head: 'Year',
    stat_nb_head: 'Sessions nb',
    stat_duration_head: 'Total duration',
  },
}
